import React, { Component, ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { bindActionCreators, Dispatch } from 'redux';
import { Auth } from "../../models/Auth";
import * as actions from "../../store/ducks/login/actions";
import {clearToken, saveToken} from '../../services/tokenVerify';
import api, {getApi} from "../../apis/backendApis";
import './login.css';

enum LoggingStatus {
    LOGGING_OK = 1,
    LOGGING_ERROR = 2,
    LOGGING_STANDING_BY = 3,
}

interface FormProps {
    login: string;
    password: string;
    status: LoggingStatus;
    isTokenValid: boolean | null;
    tokenParams: string;
    password_confirm: string;
    tokenExpirado: boolean | null;
    valid_password: boolean | null;
    message: string;
    userName: string;
    oldUser: boolean | null;
    loading: boolean;
}

interface DispatchProps {
    loggingIn(data:Auth):void
}

interface OwnProps {
    history:string[]
}

type Props = DispatchProps & OwnProps

class Login extends Component<Props, FormProps> {

    constructor(props:Props) {
        super(props);
        this.state = {
            login:'',
            password:'',
            status: LoggingStatus.LOGGING_STANDING_BY,
            isTokenValid: null,
            tokenParams: '',
            password_confirm: '',
            tokenExpirado: null,
            valid_password: null,
            message: '',
            userName: '',
            oldUser: null,
            loading: false,
        };
    }

    async componentDidMount() {
        const isTokenValid = await this.verifyFirstAcess();
        this.setState({ isTokenValid });
    }

    verifyFirstAcess = async (): Promise<boolean> => {
        let tokenParams = localStorage.getItem('first-acess-token');
        if (tokenParams === null) {
            tokenParams = '';
        }
        this.setState({ tokenParams });
        localStorage.clear();
        this.removeUrlParameter();
        let apiInstance = getApi();

        if (tokenParams) {
            clearToken();
            try {
                const response = await apiInstance.get('verificar/token/' + tokenParams);
                if (response.data?.expirado || !response.data.valido) {
                    if (response.data?.expirado){
                        let tokenExpirado = response.data?.expirado;
                        this.setState({tokenExpirado});
                    }
                    return false;
                }
                let userName = response.data?.userName;
                let oldUser = response.data?.oldUser;
                this.setState({ userName, oldUser });
                return true;
            } catch (error) {
                return false;
            }
        } else {
            return false;
        }
    };

    removeUrlParameter = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('first-acess-token');
        window.history.replaceState(null, '', url.toString());
    };

    render (){
        const onChangeInput = (e : ChangeEvent<HTMLInputElement>) => {
            const {name, value} = e.target;
            this.setState({...this.state, [name]:value});
        }

        const handleConfirm = () => {
            const {login, password} = this.state;

            const saveTokenResponse = (response:Auth) =>{
                saveToken(response.token);
                this.props.loggingIn(response);
                this.props.history.push('/');
                window.location.reload();
            }
            const handlingError = () =>{
                this.setState({ status: LoggingStatus.LOGGING_ERROR, loading: false });
            }
            const formData = new FormData();

            formData.append('login', login);
            formData.append('password', password);

            this.setState({ loading: true, message: '' });

            api.post<Auth>(
                '/auth/login',
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data'}
                }).then(reponse => {
                    //@ts-ignore
                    if (reponse.data?.authenticated){
                        saveTokenResponse(reponse.data);
                    }else {
                        //@ts-ignore
                        const message = reponse?.data?.message;
                        this.setState({ message, loading: false });
                    }
            }).catch(function (response){
                handlingError();
            });
        }

        const handleConfirmRegisterPassword = () => {
            const {password, password_confirm, tokenParams} = this.state;
            const formData = new FormData();

            formData.append('password', password);
            formData.append('password_confirm', password_confirm);
            formData.append('token', tokenParams);

            this.setState({ loading: true });

            api.post<Auth>(
                '/confirmar/senha',
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(response => {
                //@ts-ignore
                const valid_password = response?.data?.success;
                //@ts-ignore
                const message = response?.data?.message;
                this.setState({ valid_password, message, loading: false });
                if (valid_password) {
                    this.removeUrlParameter();
                    setTimeout(() => {
                        window.location.href = '/login';
                    }, 1600);
                }
            }).catch(() => {
                this.setState({ loading: false });
            });
        }

        const handleOnKeyPressLogin = (event:React.KeyboardEvent<HTMLInputElement>)=>{
            if(event.charCode == 13){
                handleConfirm();
                event.preventDefault();
            };
        }

        const { isTokenValid, loading } = this.state;

        if (isTokenValid === null) {
            return <div />;
        }

        return (
            <div className="login-wrapper">
                <div className="login-card">
                    <div className="login-brand">
                        <img src="/img/panoramasistemas.svg" alt="Panorama Sistemas" />
                        <h2>Panorama Sistemas</h2>
                        <p>Painel Administrativo</p>
                    </div>

                    {isTokenValid ? (
                        <>
                            <div style={{marginBottom: 20}}>
                                <p style={{fontSize: 15, color: '#2d3748', margin: 0}}>
                                    Bem-vindo{this.state.oldUser ? ' de volta' : ''},{' '}
                                    <strong style={{color: '#0085ff'}}>{this.state.userName}</strong>
                                </p>
                                <p style={{fontSize: 13, color: '#718096', margin: '4px 0 0'}}>
                                    Defina sua senha para continuar.
                                </p>
                            </div>

                            {this.state.valid_password === true && (
                                <div className="login-alert-success">{this.state.message}</div>
                            )}
                            {this.state.valid_password === false && (
                                <div className="login-alert-error">{this.state.message}</div>
                            )}

                            <div className="login-policy">
                                <strong>Politica de Senhas</strong>
                                <ul>
                                    <li>Minimo 12 caracteres</li>
                                    <li>Letra maiuscula e minuscula</li>
                                    <li>Pelo menos um numero</li>
                                    <li>Pelo menos um caractere especial</li>
                                    <li>Validade maxima de 365 dias</li>
                                    <li>Nao deve conter parte do nome de usuario</li>
                                </ul>
                            </div>

                            <div className="login-field">
                                <label>Nova Senha</label>
                                <input
                                    name="password"
                                    type="password"
                                    placeholder="Digite a nova senha"
                                    autoComplete="new-password"
                                    onKeyPress={handleOnKeyPressLogin}
                                    onChange={onChangeInput}
                                />
                            </div>
                            <div className="login-field">
                                <label>Confirmar Senha</label>
                                <input
                                    name="password_confirm"
                                    type="password"
                                    placeholder="Confirme a nova senha"
                                    autoComplete="new-password"
                                    onKeyPress={handleOnKeyPressLogin}
                                    onChange={onChangeInput}
                                />
                            </div>
                            <button className="login-btn" onClick={handleConfirmRegisterPassword} disabled={loading}>
                                {loading ? <><span className="login-spinner" /> Registrando...</> : 'Registrar Senha'}
                            </button>
                        </>
                    ) : (
                        <>
                            {this.state.tokenExpirado && (
                                <div className="login-alert-error">Token expirado. Solicite um novo acesso.</div>
                            )}
                            {this.state.message.length > 0 && (
                                <div className="login-alert-error">{this.state.message}</div>
                            )}
                            {this.state.status === LoggingStatus.LOGGING_ERROR && (
                                <div className="login-alert-error">Erro ao autenticar. Tente novamente.</div>
                            )}

                            <div className="login-field">
                                <label>E-mail</label>
                                <input
                                    name="login"
                                    type="text"
                                    placeholder="seu@email.com"
                                    autoComplete="username"
                                    onChange={onChangeInput}
                                />
                            </div>
                            <div className="login-field">
                                <label>Senha</label>
                                <input
                                    name="password"
                                    type="password"
                                    placeholder="••••••••"
                                    autoComplete="current-password"
                                    onKeyPress={handleOnKeyPressLogin}
                                    onChange={onChangeInput}
                                />
                            </div>
                            <button className="login-btn" onClick={handleConfirm} disabled={loading}>
                                {loading ? <><span className="login-spinner" /> Autenticando...</> : 'Entrar'}
                            </button>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        user:state.login.data?.user
    };
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    bindActionCreators(actions, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Login);
